import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

export function useSunMode() {
  const [on, setOn] = useState(() => localStorage.getItem('cv_sun_mode') === '1');
  useEffect(() => {
    document.documentElement.classList.toggle('sun-mode', on);
    return () => document.documentElement.classList.remove('sun-mode');
  }, [on]);
  const toggle = () => setOn((v) => { localStorage.setItem('cv_sun_mode', v ? '0' : '1'); return !v; });
  return [on, toggle];
}

export default function SunModeToggle() {
  const [on, toggle] = useSunMode();
  return (
    <button
      onClick={toggle}
      data-testid="sun-mode-toggle"
      title={on ? 'Repasser en thème sombre' : 'Thème clair — lecture en plein soleil'}
      className="sun-toggle-btn fixed bottom-24 right-4 z-40 w-12 h-12 rounded-full shadow-xl shadow-black/30 border border-white/15 flex items-center justify-center transition no-print"
    >
      {on ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
}
